<form #FormText="ngForm">
  <div class="app-textarea app-space-right app-space-bottom search-filter-seperator"  [hidden]="true">
    <h4 class="typo-small">{{enumSvc.getRessource("rcptNtsRefText")}}:</h4>
    <p [innerText]="values.rcptNtsRefText" class="md-textarea app-space-right typo-small"></p>
  </div>
  <app-textarea-input #VCNodeText [caption]="getTranslation('Kommentar')"
                      [maxCLength]="1024"
                      [value]="values.rcptNtsNote">
  </app-textarea-input>
</form>
